// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ARRAY_EMPTY: any[] = [];
export const OBJECT_EMPTY = {};
export const FUNC_NOOP = () => {};
export const FUNC_PREVENT_DEFAULT = (e: { preventDefault: () => void }) => e.preventDefault();
export const FUNC_STOP_PROPAGATION = (e: { stopPropagation: () => void }) => e.stopPropagation();
